// extracted by mini-css-extract-plugin
export default {"loader":"Default_loader__jCN7U","spin":"Default_spin__3TmTz"};